// notifications.web.service.ts
import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';
import { environment } from '@env/environment';
import { Firestore, doc, setDoc, getDoc } from '@angular/fire/firestore';
import { Auth } from '@angular/fire/auth';
import { ToastController, ModalController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { CustomToastService } from './custom-toast.service';
import { deleteToken } from 'firebase/messaging';
@Injectable({
  providedIn: 'root',
})
export class NotificationsWebService {
  private messaging?: Messaging; // ahora es opcional

  constructor(
    private firestore: Firestore,
    private auth: Auth,
    private toastController: ToastController,
    private modalCtrl: ModalController,
    private customToast: CustomToastService
  ) {
    // Solo inicializar messaging si estamos en Web
    if (Capacitor.getPlatform() === 'web') {
      const app = initializeApp(environment.firebaseConfig);
      this.messaging = getMessaging(app);
    } else {
      //console.log(' No se inicializa Firebase Messaging en iOS/Android WebView.');
    }
  }

  async requestPermissionAndSaveToken() {
    if (!this.messaging) {
      //console.warn(' Messaging no disponible en esta plataforma.');
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('🔒 Permiso para notificaciones no concedido.');
      return;
    }

    try {
      // 🔥 Borra token interno para forzar uno nuevo
      await deleteToken(this.messaging);

      const token = await getToken(this.messaging, {
        vapidKey: environment.notifications.vapidKey,
        serviceWorkerRegistration: await navigator.serviceWorker.ready,
      });

      //console.log('Nuevo token Web:', token);
      localStorage.setItem('push-notification-token', token);

      const currentUser = this.auth.currentUser;
      if (currentUser) {
        const userRef = doc(this.firestore, `users/${currentUser.uid}`);
        await setDoc(userRef, { pushTokenWeb: token }, { merge: true });
        //console.log(' Token Web guardado en Firestore');
      }
    } catch (err) {
      console.error(' Error obteniendo token Web:', err);
    }
  }

  listenToForeground() {
    if (!this.messaging) return;

    onMessage(this.messaging, (payload) => {
      const title = payload.notification?.title || 'Notificación';
      const message = payload.notification?.body || 'Tienes una nueva notificación';
      const targetUrl = '/'; // o úsalo dinámicamente

      this.customToast.show(title, message, targetUrl);
    });
  }
}
